import { motion } from 'framer-motion';
import { useCallback, useEffect, useState } from 'react';

import ItemRanking from './ItemRanking';

import { Paginator } from '@/components/Paginator';
import { TabType } from '@/components/Types';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { Equipo, ResponseTapTourneyData } from '@/types/tda';
import { FADE_IN_OUT } from '@/utils';

interface RankingTableProps {
  activeTab: TabType;
  tourneyData?: ResponseTapTourneyData;
}

const RankingTable = ({ tourneyData, activeTab }: RankingTableProps) => {
  const { isDesktop, isMobile } = useIsDesktop();
  const [dataTable, setDataTable] = useState<Equipo[]>([]);
  const [contentCurrentPage, setContentCurrentPage] = useState<Equipo[]>([]);

  useEffect(() => {
    if (tourneyData && tourneyData.top_fecha && tourneyData.top_general) {
      activeTab === 1
        ? setDataTable(tourneyData.top_general)
        : setDataTable(tourneyData.top_fecha);
    }
  }, [tourneyData, activeTab]);

  const initState = useCallback(() => {
    if (dataTable.length > 0 && isDesktop) {
      setContentCurrentPage(dataTable.slice(0, 10));
    } else {
      setContentCurrentPage(dataTable);
    }
  }, [isDesktop, dataTable]);

  useEffect(() => {
    initState();

    return () => {
      setContentCurrentPage([]);
    };
  }, [initState]);

  const handleContentCurrentPage = (dts: Equipo[]) => {
    dts && setContentCurrentPage(dts);
  };

  return (
    <div className="w-[calc(100%+2rem)] -left-4 relative lg:left-auto lg:w-auto">
      <div className="flex text-gdt-gray-4 font-bold text-xs lg:text-sm h-10 mt-4 lg:mt-3 items-center px-7 bg-gdt-gray-7 lg:bg-white">
        <p className="w-12 lg:w-[68px]">{isDesktop ? 'Posición' : 'Pos'}</p>
        <p className="flex-1">DT</p>
        <p className="w-[62px] text-right lg:w-[113px] lg:text-center">
          Puntos
        </p>
      </div>
      {dataTable && dataTable.length > 0 && (
        <motion.div animate={'show'} initial={'hide'} variants={FADE_IN_OUT}>
          <>
            <div className="lg:h-auto mt-6 rounded-lg bg-white">
              {isDesktop &&
                contentCurrentPage.map((item: Equipo, index: number) => {
                  return <ItemRanking key={index + item.dt} data={item} />;
                })}
              {isDesktop && dataTable.length > 0 && (
                <>
                  <Paginator
                    key={dataTable
                      .map((item) => item.nroPos + item.puntos)
                      .join('.')}
                    currentContentPage={handleContentCurrentPage}
                    items={dataTable}
                  />
                </>
              )}
              {isMobile &&
                dataTable.map((item: Equipo, index: number) => {
                  return <ItemRanking key={index + item.dt} data={item} />;
                })}
            </div>
          </>
        </motion.div>
      )}
    </div>
  );
};

export default RankingTable;
